import * as settings from "@/appConfig";

export default function getOrNoValue(val: string | number) {
  if (val === undefined || val === null || val === "") {
    return settings.NO_VALUE_DISPLAY;
  }
  return val;
}
